// import EmptyWhatsapp from "../../assets/images/empty-whatsapp.png";
import EmptyWhatsapp from "../../assets/images/whatsapp-screen-2.png";
import StoreWhatsappImage from "../../assets/images/store-whatsapp-image.png";
import Sunglasses from "../../assets/images/sunglasses.png";
import {UserOutlined} from "@ant-design/icons";
import useUserContext from "../../hooks/useUserContext";
import "./message-preview.css";
import {Dropdown, Tooltip} from "antd";
import {useEffect, useMemo, useState} from "react";
import {CONFIRM_BUTTON_OPTIONS} from "./recoveryButtonLabels/ConfirmButtonOptions";
import {OPT_OUT_BUTTON_OPTIONS} from "./recoveryButtonLabels/OptOutButtonOptions";
import {FLOW_TRIGGER_IDS} from "../../consts/flowTriggerIds";
import {SHIPMENT_FLOW_TRIGGER_IDS} from "../../consts/SHIPMENT_FLOW_TRIGGER_IDS";

interface MessagePreviewProps {
    text: string;
    isWithImage: boolean;
    feedback?: string;
    direction?: 'ltr' | 'rtl';
    flowTriggerId?: number;
    language: string;
    button1Text?: string;
    button2Text?: string;
    setButton1Text?: (newVal: string) => void;
    setButton2Text?: (newVal: string) => void;
    imageUrl?: string;
}

const MessagePreview = ({
    text,
    isWithImage,
    feedback,
    direction = 'ltr',
    flowTriggerId,
    language,
    button1Text, setButton1Text,
    button2Text, setButton2Text,
    imageUrl
}: MessagePreviewProps) => {
    const { user, selectedDomain } = useUserContext();
    // @ts-ignore
    const localizedConfirmedButtons = useMemo(() => CONFIRM_BUTTON_OPTIONS[language] || CONFIRM_BUTTON_OPTIONS['en-US'], [language]);
    // @ts-ignore
    const localizedOptOutButtons = useMemo(() => OPT_OUT_BUTTON_OPTIONS[language] || OPT_OUT_BUTTON_OPTIONS['en-US'], [language]);

    const completeOptions = localizedConfirmedButtons.map((option: any) => ({ key: option, label: option }));
    const optOutOptions = localizedOptOutButtons.map((option: any) => ({ key: option, label: option }));
    const forceNoImage = !!(flowTriggerId && SHIPMENT_FLOW_TRIGGER_IDS.includes(flowTriggerId));

    const onUpdateButton1Text = (selectedKey: string) => {
        setButton1Text?.(selectedKey);
    }

    const onUpdateButton2Text = (selectedKey: string) => {
        setButton2Text?.(selectedKey);
    }

    useEffect(() => {
        if(flowTriggerId === FLOW_TRIGGER_IDS.ABANDONED_CHECKOUT_IDENTIFICATION && (!button1Text || !localizedConfirmedButtons.includes(button1Text))) {
            setButton1Text?.(localizedConfirmedButtons[0]);
        }
        if(flowTriggerId === FLOW_TRIGGER_IDS.ABANDONED_CHECKOUT_IDENTIFICATION && (!button2Text || !localizedOptOutButtons.includes(button2Text))) {
            setButton2Text?.(localizedOptOutButtons[0]);
        }
    }, [button1Text, button2Text, localizedConfirmedButtons, localizedOptOutButtons]);

    return <>
        <img src={EmptyWhatsapp} className="preview-image"  />
        <div className="preview-image-container">
            <div className="messages-container">
                {text ? <div className={"message-container"}>
                    <div className="preview-message-sender-container"><img src={StoreWhatsappImage} className="preview-message-sender" /></div>
                    <div className="preview-message" style={{ direction }}>
                        {!forceNoImage && (isWithImage || imageUrl) ? <img src={imageUrl || Sunglasses} /> : null}
                        {text
                            .replaceAll('{{name}}', user?.name || 'Mike')
                            .replaceAll('{{cart}}', 'one pair of Sunglasses and one Luxurious Bag')
                            .replaceAll('{{price}}', '$210')
                            .replaceAll('{{shop}}', selectedDomain || '')
                            .replaceAll('{{coupon code}}', 'X41SJ552')
                        }
                        {flowTriggerId === 1 ?
                            <div className="actions">
                                <Tooltip title="Click to select different cta text">
                                    <Dropdown
                                        placement={"bottom"}
                                        trigger={['click']}
                                        menu={{
                                            items: completeOptions,
                                            className: `button-options ${direction}`,
                                            onClick: (selected) => onUpdateButton1Text(selected.key)
                                        }}
                                    >
                                        <button>{button1Text}</button>
                                    </Dropdown>
                                </Tooltip>

                                <Tooltip title="Click to select different opt-out text">
                                    <Dropdown
                                        placement={"bottom"}
                                        trigger={['click']}
                                        menu={{
                                            items: optOutOptions,
                                            className: `button-options ${direction}`,
                                            onClick: (selected) => onUpdateButton2Text(selected.key)
                                        }}
                                    >
                                        <button>{button2Text}</button>
                                    </Dropdown>
                                </Tooltip>
                            </div>
                        : null}
                    </div>
                </div> : null}
                {feedback ? <div className="message-container reverse">
                    <div className="preview-message-sender-container"><UserOutlined /></div>
                    <div className="preview-feedback">
                        {feedback}
                    </div>
                </div> : null}
            </div>
        </div>
    </>
}

export default MessagePreview;